export enum Labels {
  NEARBY_LABEL = 'Nearby',
  OTHER_LABEL = 'More',
}
